import { all, call } from "redux-saga/effects";
import { parameterSagas } from "../redux/parameters/parameterSaga";
import { productSagas } from "../redux/products/productsSaga";
import { appKeySagas } from "./appKeys/appKeySaga";

export default function* rootSaga() {
  yield all([call(parameterSagas), call(productSagas), call(appKeySagas)]);
}
